import React from 'react';
import { Link } from 'react-router-dom';
import StoreLayout from '../components/StoreLayout';
import { STORE_BASE, STORE_HOME } from '../routeBase';

// Simple line-art eyewear illustration for the 404 page — a frame with one
// lens cracked, drawn in the site's own theme colours (--sf-primary /
// --sf-accent) rather than a fixed palette, so it always matches whatever
// brand colours an entity has configured in Website Editor, per the
// standing rule that storefront art must use --sf-* vars, never a
// hardcoded/reference-image palette.
function BrokenGlassesIllustration() {
  return (
    <svg width="180" height="96" viewBox="0 0 180 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="46" cy="48" r="34" stroke="var(--sf-primary, #191919)" strokeWidth="6" />
      <circle cx="134" cy="48" r="34" stroke="var(--sf-primary, #191919)" strokeWidth="6" />
      <path d="M80 46h20" stroke="var(--sf-primary, #191919)" strokeWidth="6" strokeLinecap="round" />
      <path d="M12 40 L2 32" stroke="var(--sf-primary, #191919)" strokeWidth="6" strokeLinecap="round" />
      <path d="M168 40 L178 32" stroke="var(--sf-primary, #191919)" strokeWidth="6" strokeLinecap="round" />
      <path d="M134 22 L146 42 L128 46 L140 68" stroke="var(--sf-accent, #85cde9)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="46" cy="48" r="34" fill="var(--sf-accent, #85cde9)" fillOpacity="0.12" />
    </svg>
  );
}

export default function StoreNotFound() {
  return (
    <StoreLayout>
      <div style={{ maxWidth: 580, margin: '0 auto', padding: '80px 24px 96px', textAlign: 'center' }}>
        <BrokenGlassesIllustration />
        <div style={{
          fontSize: 76, fontWeight: 800, color: 'var(--sf-primary)', lineHeight: 1,
          margin: '22px 0 6px', letterSpacing: -2,
        }}>404</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--sf-primary)', marginBottom: 10 }}>
          We couldn't find that page
        </h1>
        <p style={{ fontSize: 14, color: '#888', lineHeight: 1.7, marginBottom: 32, maxWidth: 440, marginLeft: 'auto', marginRight: 'auto' }}>
          The page you're looking for may have been moved, renamed, or no longer exists.
          Try the search bar above, or head back to the homepage.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 40 }}>
          <Link to={STORE_HOME} className="sf-btn-outline" style={{
            textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '11px 24px', borderRadius: 24, fontSize: 13.5, fontWeight: 600,
            border: '1.5px solid var(--sf-accent)',
          }}>
            <i className="ti ti-home" /> Go to Homepage
          </Link>
          <Link to={`${STORE_BASE}/shop`} className="sf-btn-outline" style={{
            textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '11px 24px', borderRadius: 24, fontSize: 13.5, fontWeight: 600,
            border: '1.5px solid var(--sf-accent)',
          }}>
            <i className="ti ti-shopping-bag" /> Browse Shop
          </Link>
        </div>
        <div style={{ borderTop: '1px solid #eee', paddingTop: 22, display: 'flex', gap: 22, justifyContent: 'center', flexWrap: 'wrap' }}>
          {[
            [`${STORE_BASE}/shop`, 'Shop All Frames'],
            [`${STORE_BASE}/about`, 'About Us'],
            [`${STORE_BASE}/contact`, 'Contact Us'],
            [`${STORE_BASE}/orders`, 'Track an Order'],
          ].map(([to, label]) => (
            <Link key={to} to={to} style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--sf-accent)', textDecoration: 'none' }}>
              {label}
            </Link>
          ))}
        </div>
      </div>
    </StoreLayout>
  );
}
